import { render, staticRenderFns } from "./PurchaseDocumentBrowse.vue?vue&type=template&id=c4af3aac"
import script from "./PurchaseDocumentBrowse.vue?vue&type=script&lang=ts"
export * from "./PurchaseDocumentBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4af3aac')) {
      api.createRecord('c4af3aac', component.options)
    } else {
      api.reload('c4af3aac', component.options)
    }
    module.hot.accept("./PurchaseDocumentBrowse.vue?vue&type=template&id=c4af3aac", function () {
      api.rerender('c4af3aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchase/PurchaseDocumentBrowse.vue"
export default component.exports